import forResponse from '../utils/forResponse';
import { TEMPTED_BACKEND, UPDATE_STREAM_SFW_FLAG } from '../constants/apiUrls/apiUrls';

import http from './http';


export const updateSfwStreamFlag = (payload) => forResponse(http.put(UPDATE_STREAM_SFW_FLAG, payload));
export const getChatRoomAccess = (roomName, params) => forResponse(http.get(`${TEMPTED_BACKEND}/rest/v1/rooms/${roomName}/access`, { params }));